import i18n from "@breward/i18n";

export const SCHEMA_FIELD_TYPES = {
  select: {
    icon: "icon-[ph--hand-pointing]",
    label: i18n.t("global:shared.SchemaFieldType.selectLabel", "Select"),
  },
  checkbox: {
    icon: "icon-[ph--check-square]",
    label: i18n.t("global:shared.SchemaFieldType.checkboxLabel", "Checkbox"),
  },
  textarea: {
    icon: "icon-[ph--article]",
    label: i18n.t("global:shared.SchemaFieldType.textareaLabel", "Textarea"),
  },
  slider: {
    icon: "icon-[ph--sliders]",
    label: i18n.t("global:shared.SchemaFieldType.sliderLabel", "Level"),
  },
  descriptor: {
    icon: "icon-[ph--exam]",
    label: i18n.t(
      "global:shared.SchemaFieldType.descriptorLabel",
      "Descriptor"
    ),
  },
  palette: {
    icon: "icon-[ph--paint-brush]",
    label: i18n.t("global:shared.SchemaFieldType.paletteLabel", "Color"),
  },
  graph: {
    icon: "icon-[ph--chart-donut]",
    label: i18n.t("global:shared.SchemaFieldType.graphLabel", "Ratio"),
  },
};
